/* 05/10/2026 (Isma) : sélecteur de tailles façon Vanlife Store pour les options à 7 choix ou plus.
   - 5 pastilles sur ordinateur (2 lignes), 2 sur mobile (1 ligne), prises dans l'ordre des options,
     + une derniere pastille « N tailles » qui annonce le nombre total de tailles (14/10/2026, Isma)
   - la taille choisie hors des 5 premières prend la place de la 5e pastille, avec la coche ✓
   - ligne sous les pastilles : « 500 x 300 mm · ● En stock »
   - « +N tailles » et le sélecteur de la barre d'achat collante ouvrent la même fenêtre avec toutes les tailles
     (taille + stock à gauche, prix + ancien prix à droite ; épuisé grisé)
   - le menu déroulant du thème reste en place (masqué) : c'est lui qui pilote la variante, le prix, le stock, l'URL. */
/* 14/10/2026 : gris alignés sur ceux du thème (bordure #D5DFE5, fond sélectionné #F4F6F8) */
(function () {
  if (window.__evsPills) return; window.__evsPills = 1;
  var MIN = 7, N = 5, N_MOB = 2;
  /* 14/10/2026 (Isma) : 2 lignes de pastilles sur ordinateur (5 tailles + la pastille), 1 seule ligne sur
     mobile (2 tailles + la pastille) ; la derniere pastille annonce le nombre TOTAL de tailles. */
  var MQM = window.matchMedia('(max-width: 768.98px)');
  function nShow() { return MQM.matches ? N_MOB : N; }
  var L = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var MORE = { fr: 'tailles', en: 'sizes', de: 'Größen', nl: 'maten', es: 'medidas', it: 'misure', pt: 'medidas', pl: 'rozmiarów', cs: 'rozměrů', el: 'μεγέθη', da: 'størrelser', no: 'størrelser', nb: 'størrelser', sv: 'storlekar', fi: 'kokoa', hu: 'méret', ro: 'dimensiuni', hr: 'veličina', sk: 'rozmerov' }[L] || 'sizes';
  var SUB = { fr: 'Choisissez votre version', en: 'Choose your version', de: 'Wählen Sie Ihre Version', nl: 'Kies uw versie', es: 'Elija su versión', it: 'Scegli la tua versione', pt: 'Escolha a sua versão', pl: 'Wybierz wersję', cs: 'Vyberte svou verzi', el: 'Επιλέξτε την έκδοσή σας', da: 'Vælg din version', no: 'Velg din versjon', nb: 'Velg din versjon', sv: 'Välj din version', fi: 'Valitse versio', hu: 'Válassza ki a változatot', ro: 'Alegeți versiunea', hr: 'Odaberite svoju verziju', sk: 'Vyberte si verziu' }[L] || 'Choose your version';
  var CLOSE = { fr: 'Fermer', de: 'Schließen', nl: 'Sluiten', es: 'Cerrar', it: 'Chiudi', pt: 'Fechar', pl: 'Zamknij' }[L] || 'Close';
  var DIM = /^\s*\d+([.,]\d+)?\s*[x×]\s*\d+([.,]\d+)?\s*$/i;

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function mm(v, label) { return DIM.test(v) && !/mm/i.test(v) ? v + ' mm' : v; }

  function css() {
    if (document.getElementById('evs-pills-css')) return;
    var s = document.createElement('style'); s.id = 'evs-pills-css';
    s.textContent = [
      '.evs-pills{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;margin:2px 0 10px}',
      '.evs-pill{min-height:44px;padding:8px 6px;border:1px solid #D5DFE5;border-radius:9px;background:#fff;color:#2E4A5C;font:inherit;font-family:Figtree,system-ui,sans-serif;font-size:13.5px;font-weight:700;line-height:1.15;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:5px;text-align:center;-webkit-tap-highlight-color:transparent;transition:border-color .15s,box-shadow .15s}',
      '.evs-pill:hover{border-color:#1B313F}',
      '.evs-pill.is-selected{border:1.5px solid #1B313F;background:#F4F6F8;color:#1B313F;padding:7.5px 5.5px}',
      '.evs-pill__ck{font-size:12px;font-weight:800}',
      '.evs-pill--more{border:1px dashed rgba(27,49,63,.55);background:#fff;color:#1B313F;font-weight:600}',
      '.evs-pill--more span{text-decoration:underline;text-underline-offset:3px}',
      '.evs-pill--more svg{flex:0 0 auto}',
      '.evs-pills__sel{display:flex;align-items:center;flex-wrap:wrap;gap:6px;margin:0 0 6px;font-size:13.5px;color:#1B313F}',
      '.evs-pills__sel i{width:8px;height:8px;border-radius:50%;display:inline-block;background:#1F8A4C}',
      '.evs-pills__sel .is-low,.evs-pills__sel .is-rd{color:#EA7D27}.evs-pills__sel .is-low i,.evs-pills__sel .is-rd i{background:#EA7D27}',
      '.evs-pills__sel .is-oos:not(.is-rd){color:#8A959D}.evs-pills__sel .is-oos:not(.is-rd) i{background:#8A959D}',
      '.evs-pills__sel span{font-weight:600}',
      '[data-evs-pills-on]>custom-select{display:none!important}',
      /* fenêtre */
      '.evs-sheet{position:fixed;inset:0;z-index:2147483000;display:none}',
      '.evs-sheet.is-open{display:block}',
      '.evs-sheet__bg{position:absolute;inset:0;background:rgba(27,49,63,.45)}',
      '.evs-sheet__panel{position:absolute;left:0;right:0;bottom:0;max-height:72vh;background:#fff;border-radius:14px 14px 0 0;display:flex;flex-direction:column;box-shadow:0 -5px 20px rgba(0,0,0,.15);font-family:Figtree,system-ui,sans-serif;animation:evsUp .22s ease-out}',
      '@keyframes evsUp{from{transform:translateY(40px);opacity:.4}to{transform:none;opacity:1}}',
      '@media (min-width:769px){.evs-sheet__panel{left:50%;right:auto;bottom:auto;top:50%;width:440px;max-height:min(720px,82vh);transform:translate(-50%,-50%);border-radius:14px;animation:none}}',
      '.evs-sheet__head{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;padding:16px 16px 12px;border-bottom:1px solid #E6EAEC}',
      '.evs-sheet__ttl b{display:block;font-family:Archivo,sans-serif;font-size:17px;font-weight:600;color:#1B313F}.evs-sheet__ttl small{display:block;margin-top:3px;font-size:13px;color:#2E4A5C;opacity:.75}',
      '.evs-sheet__x{width:34px;height:34px;border-radius:50%;border:0;background:#F4F6F8;color:#1B313F;font-size:22px;line-height:1;cursor:pointer;flex:0 0 auto}',
      '.evs-sheet__list{overflow-y:auto;-webkit-overflow-scrolling:touch;padding:8px 10px calc(12px + env(safe-area-inset-bottom));display:flex;flex-direction:column;gap:6px}',
      '.evs-sheet__opt{display:flex;align-items:center;justify-content:space-between;gap:10px;width:100%;min-height:52px;padding:8px 12px;border:1px solid #D5DFE5;border-radius:9px;background:#fff;color:#1B313F;font:inherit;text-align:left;cursor:pointer}',
      '.evs-sheet__opt:hover{border-color:#1B313F}',
      '.evs-sheet__opt.is-current{border:1.5px solid #1B313F;background:#F4F6F8;padding:7.5px 11.5px}',
      '.evs-sheet__opt.is-out{background:#fff;border-style:dashed;color:#8A959D}',
      '.evs-sheet__name{display:flex;flex-direction:column;gap:3px;font-size:14px;font-weight:700}',
      '.evs-sheet__st{display:flex;align-items:center;gap:5px;font-size:12.5px;font-weight:600;color:#1F8A4C}',
      '.evs-sheet__st i{width:7px;height:7px;border-radius:50%;background:currentColor;display:inline-block}',
      '.evs-sheet__st.is-low,.evs-sheet__st.is-rd{color:#EA7D27}.evs-sheet__st.is-oos:not(.is-rd){color:#8A959D}',
      '.evs-sheet__price{display:flex;flex-direction:column;align-items:flex-end;gap:2px;font-family:Archivo,sans-serif;font-size:16px;font-weight:600;white-space:nowrap}',
      '.evs-sheet__price s{font-family:Figtree,system-ui,sans-serif;font-size:12.5px;font-weight:400;color:#2E4A5C;opacity:.6}',
      '.vls-satc__row--selection{position:relative}',
      '.evs-satc-pick{position:absolute;inset:0;z-index:2;background:transparent;border:0;cursor:pointer}',
      'html.evs-sheet-lock,html.evs-sheet-lock body{overflow:hidden}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ---------- fenêtre commune (pastille « +N » et barre d'achat collante) ---------- */
  var sheet, sheetCtx;
  function sheetEl() {
    if (sheet) return sheet;
    sheet = document.createElement('div'); sheet.className = 'evs-sheet'; sheet.setAttribute('data-evs-sheet', '');
    sheet.innerHTML = '<div class="evs-sheet__bg" data-close></div><div class="evs-sheet__panel" role="dialog" aria-modal="true"><div class="evs-sheet__head"><div class="evs-sheet__ttl"><b></b><small>' + esc(SUB) + '</small></div><button type="button" class="evs-sheet__x" data-close aria-label="' + esc(CLOSE) + '">×</button></div><div class="evs-sheet__list" role="listbox"></div></div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) { closeSheet(); return; }
      var o = e.target.closest('[data-v]');
      if (o && sheetCtx) { sheetCtx.pick(o.getAttribute('data-v')); closeSheet(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet(); });
    return sheet;
  }
  function openSheet(ctx) {
    var s = sheetEl(); sheetCtx = ctx;
    s.querySelector('.evs-sheet__ttl b').textContent = ctx.label;
    var h = '';
    ctx.rows().forEach(function (r) {
      h += '<button type="button" role="option" class="evs-sheet__opt' + (r.sel ? ' is-current' : '') + (r.out ? ' is-out' : '') + '" data-v="' + esc(r.v) + '" aria-selected="' + r.sel + '">' +
        '<span class="evs-sheet__name">' + esc(mm(r.v)) + (r.st ? '<small class="evs-sheet__st ' + r.cls + '"><i></i>' + esc(r.st) + '</small>' : '') + '</span>' +
        '<span class="evs-sheet__price">' + esc(r.p) + (r.c ? '<s>' + esc(r.c) + '</s>' : '') + '</span></button>';
    });
    var list = s.querySelector('.evs-sheet__list'); list.innerHTML = h;
    s.classList.add('is-open'); document.documentElement.classList.add('evs-sheet-lock');
    var cur = list.querySelector('.is-current');
    if (cur) { list.scrollTop = Math.max(0, cur.offsetTop - list.clientHeight / 2 + cur.offsetHeight / 2); }
    var x = s.querySelector('.evs-sheet__x'); try { x.focus({ preventScroll: true }); } catch (e) {}
  }
  function closeSheet() {
    if (!sheet) return;
    sheet.classList.remove('is-open'); document.documentElement.classList.remove('evs-sheet-lock');
    if (sheetCtx && sheetCtx.back) { try { sheetCtx.back.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- une option à 7 choix ou plus ---------- */
  function setup(sel) {
    if (sel.__evsPills) return sel.__evsPills;
    var cs = sel.querySelector('custom-select'); if (!cs) return null;
    var lis = [].slice.call(cs.querySelectorAll('.custom-select__option[data-value]'));
    if (lis.length < MIN) return null;
    var host = cs.parentNode;
    var label = txt(sel.querySelector('label.label')) || '';
    var wrap = document.createElement('div'); wrap.className = 'evs-pills'; wrap.setAttribute('role', 'group'); if (label) wrap.setAttribute('aria-label', label);
    var line = document.createElement('p'); line.className = 'evs-pills__sel';
    host.insertBefore(wrap, cs); host.insertBefore(line, cs);
    host.setAttribute('data-evs-pills-on', '');

    function info(li) {
      var st = li.querySelector('.evs-dd__s');
      var cls = st ? st.className.replace('evs-dd__s', '').trim() : '';
      var out = /\bis-oos\b/.test(cls) || li.classList.contains('is-unavailable') || li.getAttribute('aria-disabled') === 'true';
      return { v: li.getAttribute('data-value'), li: li, sel: li.getAttribute('aria-selected') === 'true', out: out,
        st: txt(st), cls: cls, p: txt(li.querySelector('.evs-dd__p')), c: txt(li.querySelector('.evs-dd__c')) };
    }
    function rows() { return lis.map(info); }
    function pick(v) {
      var li = lis.filter(function (x) { return x.getAttribute('data-value') === v; })[0];
      if (!li) return;
      if (typeof cs.selectOption === 'function') cs.selectOption(li); else li.click();
      setTimeout(build, 60);
    }
    var ctx = { label: label, rows: rows, pick: pick, back: null };

    function build() {
      var R = rows();
      var cur = R.filter(function (r) { return r.sel; })[0];
      /* 12/10/2026 (Isma) : meilleures ventes (metafield custom.top_variants) en tête des pastilles */
      var TOP = window.__evsTopV || [];
      var av = R.filter(function (r) { return !r.out; });
      if (TOP.length) av = av.map(function (r, i) { return [r, i]; }).sort(function (a, b) { var ia = TOP.indexOf(a[0].v), ib = TOP.indexOf(b[0].v); ia = ia < 0 ? 999 : ia; ib = ib < 0 ? 999 : ib; return ia - ib || a[1] - b[1]; }).map(function (x) { return x[0]; });
      var n = nShow();
      var show = av.slice(0, n);
      /* taille choisie hors des 5 premières (lien ?variant=, choix dans la fenêtre) : elle prend la place de la 5e pastille */
      if (cur && show.indexOf(cur) < 0) { if (show.length >= n) show[n - 1] = cur; else show.push(cur); }
      var h = '';
      show.forEach(function (r) {
        h += '<button type="button" class="evs-pill' + (r === cur ? ' is-selected' : '') + '" data-pill="' + esc(r.v) + '" aria-pressed="' + (r === cur) + '">' + (r === cur ? '<span class="evs-pill__ck" aria-hidden="true">✓</span>' : '') + esc(r.v) + '</button>';
      });
      var rest = R.length - show.length;
      if (rest > 0) h += '<button type="button" class="evs-pill evs-pill--more" data-pill-more aria-haspopup="dialog"><span>' + R.length + ' ' + esc(MORE) + '</span><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg></button>';
      if (wrap.__h !== h) { wrap.innerHTML = h; wrap.__h = h; }
      var s = cur ? '<b>' + esc(mm(cur.v)) + '</b>' + (cur.st ? '<span aria-hidden="true">·</span><span class="' + esc(cur.cls) + '" style="display:inline-flex;align-items:center;gap:6px"><i></i>' + esc(cur.st) + '</span>' : '') : '';
      if (line.__h !== s) { line.innerHTML = s; line.__h = s; }
    }
    wrap.addEventListener('click', function (e) {
      var p = e.target.closest('[data-pill]');
      if (p) { pick(p.getAttribute('data-pill')); return; }
      var m = e.target.closest('[data-pill-more]');
      if (m) { e.preventDefault(); ctx.back = m; openSheet(ctx); }
    });
    if (MQM.addEventListener) MQM.addEventListener('change', build); else if (MQM.addListener) MQM.addListener(build);
    build(); setTimeout(build, 600); setTimeout(build, 2000);
    var mo = new MutationObserver(function () { clearTimeout(mo.t); mo.t = setTimeout(build, 30); });
    mo.observe(cs, { subtree: true, attributes: true, attributeFilter: ['aria-selected', 'class', 'aria-disabled'], childList: true, characterData: true });
    sel.__evsPills = ctx;
    return ctx;
  }

  /* barre d'achat collante : son sélecteur ouvre la même fenêtre (produits à une seule option) */
  function satc(ctx, picker) {
    var bar = document.querySelector('.vls-satc'); if (!bar || bar.__evsPills) return;
    var selects = picker.querySelectorAll('.option-selector');
    if (selects.length !== 1) return;
    var row = bar.querySelector('.vls-satc__row--selection'), nat = bar.querySelector('.vls-satc__variant');
    if (!row || !nat) return;
    bar.__evsPills = 1;
    var b = document.createElement('button'); b.type = 'button'; b.className = 'evs-satc-pick'; b.setAttribute('aria-haspopup', 'dialog');
    b.setAttribute('aria-label', ctx.label);
    row.appendChild(b);
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); ctx.back = b; openSheet(ctx); });
  }

  function init() {
    css();
    document.querySelectorAll('variant-picker').forEach(function (picker) {
      var first = null;
      picker.querySelectorAll('.option-selector[data-selector-type="dropdown"]').forEach(function (sel) {
        var c = setup(sel); if (c && !first) first = c;
      });
      if (first) satc(first, picker);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* 12/10/2026 : relance rapide (toutes les 100 ms pendant 4 s) au lieu d'une seule relance à 1,5 s — les pastilles s'affichent plus tôt, moins de décalage de mise en page (CLS) */
  (function retry(k) { init(); if (k < 40) setTimeout(function () { retry(k + 1); }, 100); })(0);
})();
